export default __webpack_public_path__ + "icons/whaleProcess-9965e2.svg";